import {
  CancelOrderOutput,
  CancelOrderSelfServeInput,
} from "@redotech/redo-order-editing-common/schemas/cancel-order";

export const cancelOrderSelfServe = {
  name: "cancelOrderSelfServe" as const,
  input: CancelOrderSelfServeInput,
  output: CancelOrderOutput,
};
